module.exports = __webpack_public_path__ + "img/no_user.b8ff15f6.svg";